const BLACKOUT_DESCRIPTION = 'download.blackoutDescription';
import ecdn10AgentAPI from './AgentAPI';

interface Pref {
  value: string | number;
  type: string;
  scope: string;
  name: string;
  locked: number;
}

function hasDescriptionString(descriptions: string[], pref: Pref): boolean {
  const { value } = pref;
  if (value) {
    return descriptions.some(desc =>
      (value as string).toLowerCase().includes(desc.toLowerCase())
    );
  } else {
    return false;
  }
}

interface Response extends Pref {
  returnCode: number;
}

export default function shouldBlackoutForPrefs(
  descriptions: string[]
): Promise<boolean> {
  return new Promise(res => {
    if (descriptions.length < 1) {
      res(false);
      return;
    }
    ecdn10AgentAPI.getPref({
      name: BLACKOUT_DESCRIPTION,
      timeout: 2000,
      onSuccess: (data: Response) => {
        if (data.returnCode == 200) {
          const out = hasDescriptionString(descriptions, data);
          res(out);
        } else {
          res(false);
        }
      },
      onFailure: () => {
        res(false);
      },
      onTimeout: () => {
        res(false);
      }
    });
  });
}
